import { createFileRoute } from "@tanstack/react-router";
import { LegalPage, legalHead } from "@/pages/LegalPage";
import { cookiepolitikStrings } from "@/i18n/content/legal";

export const Route = createFileRoute("/en/cookie-and-privacy-policy")({
  head: () => legalHead("cookiepolitik", "en", cookiepolitikStrings.en.meta),
  component: () => <LegalPage {...cookiepolitikStrings.en} />,
});
